import { accountingPeriodSchema } from '../querySchema'
import { accountingPeriodTable } from '../schema'
import type { AccountingPeriod, DatabaseWithTransaction } from '../types'

type SelectAccountingPeriodListParameters = {
  readonly database: DatabaseWithTransaction
}

export const selectAccountingPeriodList = async ({
  database: { database },
}: SelectAccountingPeriodListParameters): Promise<
  readonly AccountingPeriod[]
> => {
  const data = await database.select().from(accountingPeriodTable)
  return data.map((item) => accountingPeriodSchema.parse(item))
}
